import { makeAutoObservable } from 'mobx'
import { type IEntitiesStore } from 'entities/EntitiesExport'

export class SurveysStore {
  isLoading = false
  constructor(readonly entities: IEntitiesStore) {
    makeAutoObservable(this)
  }

  init() {}

  get empty() {
    return !this.isLoading
  }

  dispose() {}
}
